import { render, staticRenderFns } from "./NewUiSwitcher.vue?vue&type=template&id=224da2c4&"
import script from "./NewUiSwitcher.vue?vue&type=script&lang=ts&"
export * from "./NewUiSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports